const es = {
  langName: "Español",
  locale: "es_ES",
  meta: {
    home: ["Fundación MADE — Derechos, salud y solidaridad", "MADE ONLUS apoya a las personas en situación de vulnerabilidad con asistencia sociosanitaria, beneficencia y formación, en la República Dominicana y en Italia."],
    about: ["Quiénes somos — Fundación MADE", "Historia, misión y valores de la Fundación MADE: construimos los derechos fundamentales de las personas poniendo a disposición nuestras competencias."],
    activities: ["Nuestras actividades — Fundación MADE", "Asistencia sociosanitaria, beneficencia, educación y formación, colaboración con profesionales sanitarios y apoyo a estructuras sociales."],
    projects: ["Proyectos — Fundación MADE", "Los proyectos documentados de MADE: La Romana en la República Dominicana y Villa Bevilacqua Relais en Rapagnano, en Las Marcas."],
    laRomana: ["Proyecto La Romana, República Dominicana — MADE", "El proyecto sociosanitario de MADE en La Romana: un hospital para las personas más necesitadas y, mientras tanto, una clínica móvil con especialistas."],
    villa: ["Villa Bevilacqua Relais, Rapagnano (FM) — MADE", "El proyecto Villa Bevilacqua Relais en Las Marcas: planos, visualizaciones 3D y características documentadas de la estructura."],
    team: ["El equipo — Fundación MADE", "La Presidenta, el Director Sanitario y el personal médico de la Fundación MADE."],
    gallery: ["Galería fotográfica — Fundación MADE", "Fotografías originales de las personas, las actividades sanitarias, los colaboradores y los proyectos de MADE."],
    donate: ["Dona ahora — Apoya a MADE ONLUS", "Apoya a MADE con una transferencia bancaria, una donación periódica mediante el formulario SDD o destinando tu 5×1000."],
    contact: ["Contacto — Fundación MADE", "Escribe a MADE ONLUS: dirección, fax, correo electrónico y formulario de contacto."],
    privacy: ["Política de privacidad — MADE", "Información sobre el tratamiento de los datos personales recogidos a través del sitio web de MADE ONLUS."],
    cookies: ["Política de cookies — MADE", "Información sobre las cookies y tecnologías similares que utiliza el sitio web de MADE ONLUS."],
    notFound: ["Página no encontrada — MADE", "La página solicitada no existe."],
  },
  nav: { home: "Inicio", about: "Quiénes somos", activities: "Actividades", projects: "Proyectos", team: "Equipo", gallery: "Galería", donate: "Donaciones", contact: "Contacto", donateNow: "Dona ahora", menu: "Abrir el menú", close: "Cerrar el menú", skip: "Ir al contenido", language: "Idioma" },
  common: {
    discover: "Descubre más",
    support: "Apoya a MADE",
    backToProjects: "Todos los proyectos",
    copy: "Copiar",
    copied: "Copiado al portapapeles",
    viewAll: "Ver todo",
    requestInfo: "Solicitar información",
    source: "Fuente: documentación de MADE",
    statusNote: "Los documentos de la fundación presentan el proyecto y sus objetivos; no contienen información sobre su finalización ni sobre su puesta en marcha.",
    projectGallery: "Galería del proyecto",
    supportProject: "Apoya este proyecto",
    supportProjectText: "Puedes indicar el proyecto que deseas apoyar en el concepto de la transferencia.",
  },
  home: {
    eyebrow: "Fundación MADE · MADE ONLUS",
    titleLines: ["Construyamos", "juntos un futuro", "mejor."],
    subtitle: "Cada gesto de solidaridad puede contribuir a proteger los derechos fundamentales de las personas y a apoyar a quienes más lo necesitan.",
    ctaMission: "Descubre nuestra misión",
    ctaSupport: "Apoya a MADE",
    scroll: "Desliza",
    marquee: ["Asistencia sociosanitaria", "Beneficencia", "Educación", "Formación", "Derechos fundamentales", "La Romana", "Rapagnano"],
    aboutEyebrow: "Quiénes somos",
    aboutTitle: "Construimos los derechos fundamentales de las personas.",
    aboutText: "Apoyamos, compartimos y ponemos nuestras competencias a disposición de las situaciones de necesidad que encontramos y que nos encuentran.",
    activitiesEyebrow: "Nuestras actividades",
    activitiesTitle: "Cuidado, apoyo y conocimiento para quienes viven en la pobreza.",
    projectsEyebrow: "Proyectos destacados",
    projectsTitle: "Dos territorios, un mismo compromiso.",
    quote: "«Tu futuro depende de lo que haces hoy, no mañana.»",
    teamEyebrow: "El equipo",
    teamTitle: "Personas que ponen su competencia al servicio de los demás.",
    galleryEyebrow: "Galería",
    galleryTitle: "Rostros, gestos, lugares.",
    donateEyebrow: "Donaciones",
    donateTitle: "Tu apoyo hace posible nuestro trabajo.",
    contactEyebrow: "Contacto",
    contactTitle: "¿Quieres conocernos, colaborar o pedir información?",
    contactText: "Escríbenos: te responderemos lo antes posible.",
  },
  about: {
    eyebrow: "Quiénes somos",
    titleLines: ["Quién es", "MADE"],
    intro: "Apoyamos, compartimos y ponemos nuestras competencias a disposición de las situaciones de necesidad que encontramos y que nos encuentran.",
    motto: "Construimos los derechos fundamentales de las personas.",
    storyTitle: "Nuestra historia",
    story: "La Presidenta de la Fundación MADE es la abogada Marzia Bevilacqua. Siempre sensible a los problemas sociales y movida por el deseo de proteger los derechos de los más desfavorecidos, creó la Fundación MADE tras un encuentro con un grupo de médicos cubanos en Santo Domingo.",
    missionTitle: "Misión",
    mission: "Garantizar la asistencia sociosanitaria a las personas más necesitadas y apoyar, mediante la beneficencia, la enseñanza y la formación, a quienes viven en condiciones de pobreza y marginación.",
    visionTitle: "Visión",
    vision: "Un futuro en el que los derechos fundamentales de cada persona estén protegidos, empezando por lo que decidimos hacer hoy.",
    valuesTitle: "Nuestros valores",
    values: [
      ["Apoyo", "Estamos junto a las situaciones de necesidad que encontramos y que nos encuentran."],
      ["Compartir", "Compartimos recursos, tiempo y experiencias con quienes más lo necesitan."],
      ["Competencia", "Ponemos a disposición competencias profesionales, empezando por las médicas."],
      ["Dignidad", "Protegemos los derechos fundamentales de cada persona."],
    ],
    italyTitle: "MADE ONLUS en Italia",
    italyText: "En Italia, la fundación actúa como MADE ONLUS, con sede en Corso Cavour 86, en Macerata, y recauda donaciones para apoyar sus actividades.",
  },
  activities: {
    eyebrow: "Actividades",
    titleLines: ["Nuestras", "actividades"],
    intro: "La Fundación MADE basa sus actividades en la asistencia sociosanitaria, la beneficencia, la enseñanza y la formación de las personas que viven en condiciones de pobreza y marginación, y contribuye con donaciones a la construcción de estructuras destinadas a cumplir su fin social.",
    items: [
      ["Asistencia sociosanitaria", "El objetivo principal de la fundación es garantizar la asistencia sociosanitaria a las personas más necesitadas, también mediante una clínica móvil capaz de llegar a las zonas más inaccesibles de la República Dominicana."],
      ["Beneficencia y apoyo a personas vulnerables", "Apoyamos a las personas que viven en condiciones de pobreza y marginación, poniendo a su disposición recursos y competencias."],
      ["Educación y formación", "La enseñanza y la formación son las herramientas con las que ofrecemos nuevas oportunidades a las personas que encontramos."],
      ["Colaboración con profesionales sanitarios", "El personal médico y paramédico que MADE pone a disposición está formado por un equipo de especialistas de origen cubano."],
      ["Estructuras e iniciativas sociales", "Contribuimos con donaciones a la construcción de estructuras destinadas a cumplir nuestro fin social."],
    ],
    structures: ["Hospitales", "Pozos", "Centros sociales", "Escuelas"],
    structuresNote: "Ejemplos de estructuras indicados en los documentos de la fundación.",
  },
  projects: {
    eyebrow: "Proyectos",
    titleLines: ["El", "proyecto"],
    intro: "Los proyectos presentados en los documentos de la fundación: una intervención sociosanitaria en la República Dominicana y una estructura en Las Marcas, Italia.",
    objectivesTitle: "Objetivos documentados",
    laRomana: {
      name: "La Romana",
      place: "La Romana · República Dominicana",
      short: "La construcción de un hospital para garantizar la asistencia sociosanitaria a las personas más necesitadas y, mientras tanto, una clínica móvil.",
      intro: "La obra que la Fundación MADE pretende realizar, con el objetivo principal de garantizar la asistencia sociosanitaria a las personas más necesitadas, será la construcción de un hospital.",
      objectives: [
        "Construcción de un hospital para la asistencia sociosanitaria de las personas más necesitadas.",
        "Uso, a la espera de la estructura hospitalaria, de una clínica móvil capaz de llegar incluso a las zonas más inaccesibles de la República Dominicana.",
        "Puesta a disposición de personal médico y paramédico especializado.",
      ],
      specialistsTitle: "Las especialidades del equipo médico",
      specialistsText: "Actualmente, el personal médico y paramédico que la Fundación MADE pone a disposición está formado por un equipo de especialistas, todos de origen cubano, en:",
      specialists: ["Ortopedia", "Urología", "Ginecología", "Medicina general", "Medicina interna", "Anestesiología"],
    },
    villa: {
      name: "Villa Bevilacqua Relais",
      place: "Rapagnano (FM) · Las Marcas · Italia",
      short: "El proyecto de una estructura de cuatro niveles, con espacios para el cuidado de la persona, consultorios, habitaciones, jardines en azotea y una guardería agrícola con animales.",
      intro: "El proyecto Villa Bevilacqua Relais, en Rapagnano, provincia de Fermo, se presenta en la documentación con una vista aérea del terreno, los planos de cada planta y visualizaciones 3D de la estructura.",
      objectives: [
        "Una estructura que prevé una guardería agrícola (agrinido) con animales, un área de acogida para los animales y una zona de juegos infantiles.",
        "En la planta baja: comedor, gimnasio, fisioterapia, cuidado de la persona y consultorios.",
        "Módulo de 20/22 plazas con la estructura existente, con habitaciones en la primera y la segunda planta.",
      ],
      floorsTitle: "Los planos",
      floors: [
        ["Semisótano", "Cocina (h 3,40 m), espacios para el personal, lavandería y sala de calderas. Módulo de 20/22 plazas con la estructura existente (habitaciones en la primera y segunda planta con requisitos de acreditación menores).", "planSB"],
        ["Planta baja", "Comedor 150 m², gimnasio 150 m², sala de ocio 85 m², fisioterapia 50 m², servicios 40 m², cuidado de la persona 65 m², sala de reuniones 150 m², oficinas 50 m², recepción 60 m², consultorios y servicios 185 m².", "planGF"],
        ["Primera planta", "Ocho habitaciones con baño, espacio para el personal y jardín en azotea. Superficie disponible: 16 plazas en 8 habitaciones.", "planFF"],
        ["Segunda planta (bajo cubierta)", "Habitaciones, sala del personal, salida a la escalera de emergencia y jardín en azotea. Superficie disponible: 6 plazas en 2 habitaciones, o 4 plazas en 1 habitación con sala del personal.", "planSF"],
      ],
      renderTitle: "Visualizaciones 3D",
      renderText: "La estructura prevé una guardería agrícola con animales, con un área de acogida para los animales y una zona de juegos para los niños.",
      aerialTitle: "El terreno",
      aerialText: "Vista aérea del terreno de Villa Bevilacqua Relais en Rapagnano (FM).",
      elevationsTitle: "Alzados",
    },
  },
  team: {
    eyebrow: "Equipo",
    titleLines: ["El", "equipo"],
    intro: "Las personas presentadas en el folleto de la fundación y el personal sanitario que MADE pone a disposición.",
    presidentRole: "La Presidenta",
    presidentName: "Abg. Marzia Bevilacqua",
    presidentBio: "Siempre sensible a los problemas sociales y movida por el deseo de proteger los derechos de los más desfavorecidos, creó la Fundación MADE tras un encuentro con un grupo de médicos cubanos en Santo Domingo.",
    directorRole: "El Director Sanitario",
    directorName: "Dr. Dennis Livan Gonzalez Martinez",
    directorBio: [
      "Licenciado en Medicina y Cirugía por el Instituto Superior de Ciencias Médicas de La Habana, Cuba, se especializa en Ortopedia y Traumatología.",
      "Trabaja durante años en los institutos pediátricos más reconocidos de La Habana.",
      "En 2007, en misión humanitaria por cuenta del Gobierno cubano, es enviado a Haití, donde atiende a las víctimas del terrible terremoto de 2010.",
      "En 2012 se traslada a la República Dominicana. En 2015 llega a Italia.",
      "En torno a su experiencia, sus capacidades y su humanidad, la Fundación MADE construye su labor y le confía su operatividad.",
    ],
    staffTitle: "Personal médico y colaboradores",
    staffText: "El personal médico y paramédico de MADE está formado por un equipo de especialistas de origen cubano. Las fotografías proceden de la documentación de la fundación.",
  },
  gallery: {
    eyebrow: "Galería",
    titleLines: ["Galería", "fotográfica"],
    intro: "Fotografías originales procedentes de la documentación de la fundación.",
    all: "Todas",
    cats: { people: "Personas y comunidades", health: "Actividades sanitarias", volunteers: "Voluntarios y colaboradores", projects: "Proyectos y estructuras", architecture: "Documentación arquitectónica" },
    close: "Cerrar",
    prev: "Imagen anterior",
    next: "Imagen siguiente",
    open: "Ampliar imagen",
    captions: {
      handsWater: "Manos y agua — imagen de portada del folleto de MADE",
      smilingGirls: "Dos niñas sonrientes",
      girlBlue: "Una niña con camiseta azul",
      baby: "Un niño en brazos",
      twoChildren: "Dos niños",
      childCap: "Un niño con gorra amarilla en el hospital",
      childBed: "Un pequeño paciente",
      drDennis: "Dr. Dennis Livan Gonzalez Martinez, Director Sanitario",
      doctors: "Médicos con bata",
      staff: "Personal sanitario",
      teamShirts: "El grupo MADE con las camisetas de la fundación",
      volunteerChild: "Un colaborador con un niño",
      volunteerElderly: "Una colaboradora de MADE con una persona mayor",
      selfie: "Una colaboradora con algunos niños",
      kidsBanner: "Niños delante del logotipo de MADE",
      drafting: "El proyecto — La Romana, República Dominicana",
      aerial: "Villa Bevilacqua Relais — vista aérea, Rapagnano (FM)",
      render3d: "Villa Bevilacqua Relais — visualización 3D",
      agrinido: "Visualización 3D: guardería agrícola con animales y zona de juegos",
      planSB: "Plano — semisótano",
      planGF: "Plano — planta baja",
      planFF: "Plano — primera planta",
      planSF: "Plano — segunda planta (bajo cubierta)",
      elevations: "Alzados de la estructura",
    },
  },
  donate: {
    eyebrow: "Donaciones",
    titleLines: ["Dona ahora", "a MADE Italia"],
    intro: "Ayúdanos a apoyar a la ONLUS MADE en sus actividades.",
    bankTitle: "Transferencia a cuenta corriente",
    ibanLabel: "IBAN",
    bankLabel: "En",
    holderLabel: "Titular",
    causalLabel: "Concepto",
    causal: "Si quieres que tu donación apoye un proyecto concreto, puedes indicarlo en el concepto.",
    sddTitle: "Donación periódica",
    sddText: "Las donaciones periódicas realizadas mediante el formulario SDD (antes RID) se efectúan como transferencia periódica con domiciliación automática. Son muy importantes para nosotros: nos permiten programar mejor nuestras actividades y planificar nuestras iniciativas e intervenciones a medio y largo plazo.",
    sddThanks: "Gracias por ayudarnos a dar a conocer esta forma de apoyo entre las personas cercanas a ti.",
    sddHow: "Solicita el formulario SDD, rellénalo y envíanoslo por fax o por correo electrónico.",
    fiveTitle: "5×1000",
    fiveText: "Para contribuyentes en Italia: si aún no has destinado tu 5×1000, recuerda nuestro código fiscal:",
    cfLabel: "Código fiscal",
    ctaInfo: "Solicitar información",
    ctaSdd: "Solicitar el formulario SDD",
    noOnline: "Este sitio no recoge pagos en línea: las donaciones se realizan exclusivamente mediante transferencia bancaria, formulario SDD o 5×1000.",
    copyIban: "Copiar IBAN",
    copyCf: "Copiar código fiscal",
  },
  contact: {
    eyebrow: "Contacto",
    titleLines: ["Escríbenos"],
    intro: "Para información, colaboraciones o para solicitar el formulario de donación periódica.",
    detailsTitle: "Datos de contacto",
    addressLabel: "Dirección",
    faxLabel: "Fax",
    emailLabel: "Correo electrónico",
    form: {
      title: "Formulario de contacto",
      name: "Nombre y apellidos",
      email: "Correo electrónico",
      subject: "Asunto",
      message: "Mensaje",
      consent: "He leído la política de privacidad y acepto el tratamiento de mis datos para recibir una respuesta.",
      privacyLink: "Leer la política de privacidad",
      submit: "Enviar mensaje",
      sending: "Enviando…",
      success: "¡Gracias! Tu mensaje se ha enviado correctamente. Te responderemos lo antes posible.",
      error: "Se ha producido un error durante el envío. Inténtalo de nuevo más tarde o escríbenos por correo electrónico.",
      required: "Campo obligatorio",
      invalidEmail: "Introduce una dirección de correo válida",
      consentRequired: "Es necesario aceptar la política de privacidad",
      minMessage: "El mensaje debe contener al menos 10 caracteres",
      requiredNote: "Todos los campos son obligatorios.",
    },
  },
  footer: {
    tagline: "Construimos los derechos fundamentales de las personas.",
    navTitle: "Navegación",
    contactTitle: "Contacto",
    donateTitle: "Apóyanos",
    rights: "Todos los derechos reservados.",
    privacy: "Privacidad",
    cookies: "Cookies",
    cookieSettings: "Preferencias de cookies",
    photos: "Fotografías e imágenes: documentación original de MADE.",
  },
  cookie: {
    text: "Solo utilizamos el almacenamiento técnico necesario para el funcionamiento del sitio. Con tu consentimiento, la plataforma que aloja el sitio puede recopilar estadísticas de uso.",
    accept: "Aceptar",
    reject: "Solo necesarias",
    more: "Política de cookies",
  },
  legal: {
    privacyTitle: "Política de privacidad",
    privacy: [
      ["Responsable del tratamiento", "MADE ONLUS, Corso Cavour 86 – 62100 Macerata (Italia). Código fiscal 93078840431. Correo electrónico: madeonlus-italia@gmail.com."],
      ["Datos recogidos", "A través del formulario de contacto recogemos nombre, correo electrónico, asunto y texto del mensaje, además del idioma del sitio y la fecha de envío."],
      ["Finalidad y base jurídica", "Los datos se tratan exclusivamente para responder a tu solicitud, sobre la base de tu consentimiento (art. 6, apdo. 1, letra a del Reglamento (UE) 2016/679)."],
      ["Conservación", "Los datos se conservan durante el tiempo necesario para gestionar la solicitud y no se ceden a terceros con fines comerciales."],
      ["Tus derechos", "Puedes solicitar en cualquier momento el acceso, la rectificación, la supresión o la limitación de tus datos, retirar tu consentimiento y presentar una reclamación ante la autoridad de control, escribiendo al correo electrónico del responsable."],
    ],
    cookiesTitle: "Política de cookies",
    cookies: [
      ["Almacenamiento técnico", "El sitio guarda en tu navegador tu elección sobre las cookies. Esta información es necesaria para el funcionamiento del sitio y no requiere consentimiento."],
      ["Estadísticas de la plataforma", "La plataforma que aloja el sitio puede utilizar herramientas de medición de uso. Solo se activan si aceptas en el banner; al elegir «Solo necesarias», la recopilación se desactiva."],
      ["Gestión de preferencias", "Puedes cambiar tu elección en cualquier momento mediante el enlace «Preferencias de cookies» del pie de página."],
    ],
  },
  notFound: { title: "Página no encontrada", text: "La página que buscas no existe o ha sido trasladada.", back: "Volver al inicio" },
};

export default es;
